import { IQuestion } from "./../global/interfaces/httprequestinterface";
import { BaseHTTPClient } from "@/network/basehttpclient";
import {
  GetCSSQuestion,
  GetCSSQuestionCategory,
  UpdateCSSQuestion,
} from "@/network/httprequestentities/httpconfig";
import { CSSQuestion, QuestionCategory } from "@/global/interfaces";

export class AllQuestionRepository extends BaseHTTPClient {
  constructor() {
    super();
  }

  public async getQuestionCategories(id: string): Promise<QuestionCategory[]> {
    try {
      const response = await this.request<any>(new GetCSSQuestionCategory(id));
      return response.result?.data || [];
    } catch (error) {
      return [];
    }
  }

  public async getCssQuestion(id: string): Promise<CSSQuestion[]> {
    try {
      const response = await this.request<any>(new GetCSSQuestion(id));
      return response?.result?.data || [];
    } catch (error) {
      return [];
    }
  }

  public async updateCssQuestion(questionData: IQuestion): Promise<boolean> {
    try {
      await this.request<any>(new UpdateCSSQuestion(questionData));
      return true;
    } catch (error) {
      return false;
    }
  }
}

export let allQuestionRepository = new AllQuestionRepository();
